var $ = global.$;

/**
 * Some useful utilities
 * @exports lib/utils
 * @author Simon Buerger
 */
var utils = {
  /**
   * Cross-browser method for getting the window dimensions
   *
   * @returns {Object} Object with two parameters - width and height
   * @instance
   */
  getWindow: function(){
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

    return {
      width: x,
      height: y
    };
  },
  uniqueId: 0,
  getUniqueId: function() {
    return this.uniqueId++;
  }
};

module.exports = utils;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/lib/utils.js
// module id = 124
// module chunks = 0